module.exports = __webpack_public_path__ + "img/logo.eca40c36.png";